import { CartAssignmentList } from './CartAssignmentList';
import { CartCalendar } from './calendar/CartCalendar';
import { cartServices } from 'src/services';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { RadioSelector } from 'src/components/_commons';
import { typeCartsDoc, typeCartAssignment } from '@monorepo/models';
import { useDispatch } from 'react-redux';

type propsType = {
    cartsDoc: typeCartsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const CartAssignment: FC<propsType> = ({ cartsDoc, setRefreshCounter }) => {
    const [radioValue, setRadioValue] = useState<'calendar' | 'list'>('calendar');
    // const [showFormAdd, setShowFormAdd] = useState(false);
    const dispatch = useDispatch();

    const deleteAssignment = (assignment: typeCartAssignment) => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se va a eliminar esta Asignación de ${assignment.participants[0].name} ${assignment.participants[0].lastName} y ${assignment.participants[1].name} ${assignment.participants[1].lastName} en ${assignment.name}. Esta acción es irreversible.`,
            animation: 3,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await cartServices.DeleteAssignment(assignment);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                setRefreshCounter(x => x + 1);
            }
        }));
    }

    // useEffect(() => {
    //     helpers.GoToTop();
    // }, [showFormAdd]);

    return (
        <div>
            <RadioSelector
                options={[
                    { label: radioValue === 'calendar' ? 'Viendo Calendarios' : 'Ver Calendarios', type: 'calendar' },
                    { label: radioValue === 'list' ? 'Viendo Lista' : 'Ver Lista', type: 'list' }
                ]}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === 'calendar' ?
                <CartCalendar
                    cartsDoc={cartsDoc}
                    deleteAssignment={deleteAssignment}
                    nextMonth={false}
                    setRefreshCounter={setRefreshCounter}
                    thisMonth={false}
                />
                :
                <CartAssignmentList
                    cartsDoc={cartsDoc}
                    deleteAssignment={deleteAssignment}
                    setRefreshCounter={setRefreshCounter}
                />
            }
        </div>
    );
}
